// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epw-disclaimer-page {
  --epw-red: var(--primary);
  --epw-red-dark: var(--primary-hover);
  --epw-ink: var(--text-primary);
  --epw-muted: var(--text-secondary);
  --epw-line: var(--border);
  --epw-soft: var(--hover);
  --epw-white: var(--card-bg);
  --epw-max-width: 1000px;
  --epw-radius: 16px;
  --epw-band-bg: var(--surface-dark);
  --epw-shadow: 0 8px 28px var(--shadow);
}


    .epw-disclaimer-page, .epw-disclaimer-page * { box-sizing: border-box; }

    .epw-disclaimer-page {
      font-family:
        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
        "Segoe UI", sans-serif;
      color: var(--epw-ink);
      background: var(--epw-white);
      line-height: 1.7;
    }

    .epw-disclaimer-page {
      width: 100%;
    }

    .epw-disclaimer-hero {
      padding: 68px 24px 60px;
      background: var(--epw-soft);
      border-bottom: 1px solid var(--epw-line);
    }

    .epw-wrap {
      width: min(100%, var(--epw-max-width));
      margin: 0 auto;
    }

    .epw-eyebrow {
      margin: 0 0 12px;
      color: var(--epw-red);
      font-size: 0.8rem;
      font-weight: 800;
      letter-spacing: 0.12em;
      text-transform: uppercase;
    }

    .epw-disclaimer-hero h1 {
      margin: 0;
      font-size: clamp(2.2rem, 5vw, 4rem);
      line-height: 1.08;
      letter-spacing: -0.04em;
    }

    .epw-disclaimer-hero p {
      max-width: 780px;
      margin: 20px 0 0;
      color: var(--epw-muted);
      font-size: clamp(1.02rem, 2vw, 1.18rem);
    }

    .epw-disclaimer-main {
      padding: 54px 24px 72px;
    }

    .epw-notice {
      padding: 22px 24px;
      margin-bottom: 34px;
      border-left: 4px solid var(--epw-red);
      border-radius: 12px;
      background: var(--epw-soft);
      color: var(--epw-muted);
    }

    .epw-notice strong {
      color: var(--epw-ink);
    }

    .epw-section {
      padding: 26px 0;
      border-bottom: 1px solid var(--epw-line);
    }

    .epw-section:last-of-type {
      border-bottom: 0;
    }

    .epw-section h2 {
      margin: 0 0 10px;
      font-size: clamp(1.25rem, 2vw, 1.55rem);
      letter-spacing: -0.02em;
    }

    .epw-section p {
      margin: 0 0 12px;
      color: var(--epw-muted);
    }

    .epw-section p:last-child {
      margin-bottom: 0;
    }

    .epw-section ul {
      margin: 10px 0 0;
      padding-left: 22px;
      color: var(--epw-muted);
    }

    .epw-section li + li {
      margin-top: 6px;
    }

    .epw-highlight {
      margin: 34px 0;
      padding: 26px;
      border: 1px solid var(--epw-line);
      border-radius: var(--epw-radius);
      box-shadow: var(--epw-shadow);
      background: var(--epw-white);
    }

    .epw-highlight h2 {
      margin: 0 0 10px;
      font-size: 1.35rem;
    }

    .epw-highlight p {
      margin: 0;
      color: var(--epw-muted);
    }

    .epw-contact {
      margin-top: 42px;
      padding: 28px;
      border-radius: 18px;
      background: var(--epw-band-bg);
      color: #ffffff;
    }

    .epw-contact h2 {
      margin: 0 0 8px;
      font-size: 1.4rem;
    }

    .epw-contact p {
      margin: 0;
      color: #d8dde6;
    }

    .epw-contact a {
      color: var(--epw-white);
      text-underline-offset: 3px;
    }

    .epw-updated {
      margin-top: 18px;
      font-size: 0.88rem;
      color: var(--epw-muted);
    }

    @media (max-width: 640px) {
      .epw-disclaimer-hero {
        padding: 52px 20px 46px;
      }

      .epw-disclaimer-main {
        padding: 40px 18px 56px;
      }

      .epw-notice,
      .epw-highlight,
      .epw-contact {
        padding: 21px;
      }
    }
  `, "",{"version":3,"sources":["webpack://./src/pages/DisclaimerPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;AACxC;;;IAGI,+CAA+C,sBAAsB,EAAE;;IAEvE;MACE;;8BAEwB;MACxB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,uBAAuB;MACvB,2BAA2B;MAC3B,wCAAwC;IAC1C;;IAEA;MACE,sCAAsC;MACtC,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;MACrB,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,yBAAyB;IAC3B;;IAEA;MACE,SAAS;MACT,mCAAmC;MACnC,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,uBAAuB;MACvB,uCAAuC;IACzC;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;MACnB,qCAAqC;MACrC,mBAAmB;MACnB,2BAA2B;MAC3B,uBAAuB;IACzB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,eAAe;MACf,wCAAwC;IAC1C;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,uCAAuC;MACvC,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,uBAAuB;IACzB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,aAAa;MACb,iCAAiC;MACjC,gCAAgC;MAChC,6BAA6B;MAC7B,4BAA4B;IAC9B;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,SAAS;MACT,cAAc;IAChB;;IAEA;MACE,uBAAuB;MACvB,0BAA0B;IAC5B;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,uBAAuB;IACzB;;IAEA;MACE;QACE,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;;MAEA;;;QAGE,aAAa;MACf;IACF","sourcesContent":[".epw-disclaimer-page {\n  --epw-red: var(--primary);\n  --epw-red-dark: var(--primary-hover);\n  --epw-ink: var(--text-primary);\n  --epw-muted: var(--text-secondary);\n  --epw-line: var(--border);\n  --epw-soft: var(--hover);\n  --epw-white: var(--card-bg);\n  --epw-max-width: 1000px;\n  --epw-radius: 16px;\n  --epw-band-bg: var(--surface-dark);\n  --epw-shadow: 0 8px 28px var(--shadow);\n}\n\n\n    .epw-disclaimer-page, .epw-disclaimer-page * { box-sizing: border-box; }\n\n    .epw-disclaimer-page {\n      font-family:\n        Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n        \"Segoe UI\", sans-serif;\n      color: var(--epw-ink);\n      background: var(--epw-white);\n      line-height: 1.7;\n    }\n\n    .epw-disclaimer-page {\n      width: 100%;\n    }\n\n    .epw-disclaimer-hero {\n      padding: 68px 24px 60px;\n      background: var(--epw-soft);\n      border-bottom: 1px solid var(--epw-line);\n    }\n\n    .epw-wrap {\n      width: min(100%, var(--epw-max-width));\n      margin: 0 auto;\n    }\n\n    .epw-eyebrow {\n      margin: 0 0 12px;\n      color: var(--epw-red);\n      font-size: 0.8rem;\n      font-weight: 800;\n      letter-spacing: 0.12em;\n      text-transform: uppercase;\n    }\n\n    .epw-disclaimer-hero h1 {\n      margin: 0;\n      font-size: clamp(2.2rem, 5vw, 4rem);\n      line-height: 1.08;\n      letter-spacing: -0.04em;\n    }\n\n    .epw-disclaimer-hero p {\n      max-width: 780px;\n      margin: 20px 0 0;\n      color: var(--epw-muted);\n      font-size: clamp(1.02rem, 2vw, 1.18rem);\n    }\n\n    .epw-disclaimer-main {\n      padding: 54px 24px 72px;\n    }\n\n    .epw-notice {\n      padding: 22px 24px;\n      margin-bottom: 34px;\n      border-left: 4px solid var(--epw-red);\n      border-radius: 12px;\n      background: var(--epw-soft);\n      color: var(--epw-muted);\n    }\n\n    .epw-notice strong {\n      color: var(--epw-ink);\n    }\n\n    .epw-section {\n      padding: 26px 0;\n      border-bottom: 1px solid var(--epw-line);\n    }\n\n    .epw-section:last-of-type {\n      border-bottom: 0;\n    }\n\n    .epw-section h2 {\n      margin: 0 0 10px;\n      font-size: clamp(1.25rem, 2vw, 1.55rem);\n      letter-spacing: -0.02em;\n    }\n\n    .epw-section p {\n      margin: 0 0 12px;\n      color: var(--epw-muted);\n    }\n\n    .epw-section p:last-child {\n      margin-bottom: 0;\n    }\n\n    .epw-section ul {\n      margin: 10px 0 0;\n      padding-left: 22px;\n      color: var(--epw-muted);\n    }\n\n    .epw-section li + li {\n      margin-top: 6px;\n    }\n\n    .epw-highlight {\n      margin: 34px 0;\n      padding: 26px;\n      border: 1px solid var(--epw-line);\n      border-radius: var(--epw-radius);\n      box-shadow: var(--epw-shadow);\n      background: var(--epw-white);\n    }\n\n    .epw-highlight h2 {\n      margin: 0 0 10px;\n      font-size: 1.35rem;\n    }\n\n    .epw-highlight p {\n      margin: 0;\n      color: var(--epw-muted);\n    }\n\n    .epw-contact {\n      margin-top: 42px;\n      padding: 28px;\n      border-radius: 18px;\n      background: var(--epw-band-bg);\n      color: #ffffff;\n    }\n\n    .epw-contact h2 {\n      margin: 0 0 8px;\n      font-size: 1.4rem;\n    }\n\n    .epw-contact p {\n      margin: 0;\n      color: #d8dde6;\n    }\n\n    .epw-contact a {\n      color: var(--epw-white);\n      text-underline-offset: 3px;\n    }\n\n    .epw-updated {\n      margin-top: 18px;\n      font-size: 0.88rem;\n      color: var(--epw-muted);\n    }\n\n    @media (max-width: 640px) {\n      .epw-disclaimer-hero {\n        padding: 52px 20px 46px;\n      }\n\n      .epw-disclaimer-main {\n        padding: 40px 18px 56px;\n      }\n\n      .epw-notice,\n      .epw-highlight,\n      .epw-contact {\n        padding: 21px;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
